import Controller from "./scheduleWeekdays.controller";
import template from "./scheduleWeekdays.html";

const scheduleWeekdays = {
  template,
  controller: Controller,
  bindings: {
    weekDaysArray: "=?",
    isDisabled: "@",
    selectedDays: "=?",
    showEdit: "<",
    title: "@",
    showTitle: "<",
    eventName: "<",
    name: "@",
    size: "@",
    resourceMethodName: "@",
  },
};

export default scheduleWeekdays;



// WEBPACK FOOTER //
// ./src/components/scheduleWeekdays/scheduleWeekdays.component.js